import { Link } from "react-router-dom";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { brand, footerLinks } from "@/mocks/site";

const columns = [
  { title: "内容浏览", links: footerLinks.browse },
  { title: "关于与规则", links: footerLinks.about },
  { title: "参与我们", links: footerLinks.service },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-secondary-100">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-control bg-accent-500 text-secondary-950 flex items-center justify-center font-heading text-xl font-bold">
                瓜
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{brand.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-sm">
              {brand.description}
            </p>
            <dl className="mt-6 space-y-2 text-sm">
              <div className="flex gap-2">
                <dt className="text-secondary-300 w-16 shrink-0">鉴定咨询</dt>
                <dd className="text-secondary-100 break-all">{brand.email}</dd>
              </div>
              <div className="flex gap-2">
                <dt className="text-secondary-300 w-16 shrink-0">线索投稿</dt>
                <dd className="text-secondary-100 break-all">{brand.tipEmail}</dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-bold text-background-50 tracking-wide">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-secondary-200 hover:text-accent-400 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50 tracking-wide">
              每周鉴定播报
            </h4>
            <p className="mt-3 mb-4 text-sm text-secondary-200 leading-relaxed">
              用一封邮件，收下本周新增的实锤、反转与辟谣汇总。
            </p>
            <NewsletterForm variant="footer" />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© 2026 {brand.name} · 本站内容为爆料可信度分析，不构成对任何人的事实认定。</p>
          <p className="flex items-center gap-4">
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              鉴定方法
            </Link>
            <Link to="/faq" className="hover:text-accent-400 transition-colors">
              内容原则
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}